import React, { Component } from 'react';
import { Button, Form, FormGroup, Label, Input, Alert, Card, CardBody, CardTitle } from 'reactstrap';
import { Navigate } from 'react-router-dom';

export class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      error: null,
      loading: false,
      redirectToHome: false,
      redirectPath: '/order'
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { username, email, password, confirmPassword } = this.state;

    if (!username || !email || !password || !confirmPassword) {
      this.setState({ error: 'Please fill in all fields' });
      return;
    }

    if (password !== confirmPassword) {
      this.setState({ error: 'Passwords do not match' });
      return;
    }

    if (password.length < 6) {
      this.setState({ error: 'Password must be at least 6 characters' });
      return;
    }

    this.setState({ loading: true, error: null });

    try {
      const response = await fetch('api/auth/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, email, password, role: 0 })
      });

      if (response.ok) {
        const data = await response.json();
        // Store user data in localStorage
        localStorage.setItem('user', JSON.stringify(data));
        // Redirect to order page (all new registrations are customers)
        this.setState({ redirectToHome: true, redirectPath: '/order' });
        // Notify parent component
        if (this.props.onLogin) {
          this.props.onLogin(data);
        }
      } else {
        const error = await response.json();
        this.setState({ error: error.message || 'Registration failed', loading: false });
      }
    } catch (error) {
      console.error('Registration error:', error);
      this.setState({ error: 'An error occurred during registration', loading: false });
    }
  };

  render() {
    const { username, email, password, confirmPassword, error, loading, redirectToHome, redirectPath } = this.state;

    if (redirectToHome) {
      return <Navigate to={redirectPath} />;
    }

    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '70vh' }}>
        <Card style={{ width: '400px' }} className="coffee-card">
          <CardBody className="p-4">
            <CardTitle tag="h3" className="text-center mb-2" style={{ fontFamily: 'var(--font-display)', color: 'var(--moss-dark)' }}>
              Join Us
            </CardTitle>
            <p className="text-center text-muted mb-4" style={{ fontSize: '0.9rem' }}>
              Create your account for a personalized experience
            </p>
            
            {error && (
              <Alert color="danger">{error}</Alert>
            )}

            <Form onSubmit={this.handleSubmit}>
              <FormGroup>
                <Label for="username">Username</Label>
                <Input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => this.setState({ username: e.target.value })}
                  disabled={loading}
                  autoFocus
                />
              </FormGroup>

              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  disabled={loading}
                />
              </FormGroup>

              <FormGroup>
                <Label for="password">Password</Label>
                <Input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => this.setState({ password: e.target.value })}
                  disabled={loading}
                />
              </FormGroup>

              <FormGroup>
                <Label for="confirmPassword">Confirm Password</Label>
                <Input
                  type="password"
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                  disabled={loading}
                />
              </FormGroup>

              <Button color="primary" type="submit" block disabled={loading}>
                {loading ? 'Registering...' : 'Register'}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <p className="mb-0" style={{ color: 'var(--warm-gray)' }}>
                Already a member? <a href="/login" style={{ color: 'var(--moss)' }}>Sign in</a>
              </p>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

